import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import Con from '../../static/config.json'

Vue.use(Vueaxios, axios)
const URL = Con.URL
export default {
  getZone (obj, header, success, error) {
    Vue.axios.post(URL + 'homezone/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  searchIncome (obj, header, success, error) {
    Vue.axios.post(URL + 'historyincome/search', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  IncomeDetail (id, header, success, error) {
    Vue.axios.get(URL + 'historyincome/' + id, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateIncome (obj, header, success, error) {
    Vue.axios.post(URL + 'historyincome', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getWaterHistory (homeid, header, success, error) {
    Vue.axios.get(URL + 'historyincome/historywater/' + homeid, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getWaterHistoryPost (obj, header, success, error) {
    Vue.axios.post(URL + 'historyincome/historywater', obj, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_income.js